import { NgModule } from '@angular/core';
import { AppSharedModule } from '@gestor-web/app/shared/modules';
import { EditorTextoFormatacaoComponent } from './editor-texto-formatacao.component';

@NgModule({
  declarations: [EditorTextoFormatacaoComponent],
  exports: [EditorTextoFormatacaoComponent],
  imports: [AppSharedModule],
})
export class EditorTextoFormatacaoModule {}
